"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _lodash = require("lodash");

// This will eventually become a problem since we'll want to clear the state when we get a new analytics url.
var QueryStore = function QueryStore() {
  var $ = new _rxjs.BehaviorSubject().pipe((0, _operators.scan)(function (state, action) {
    if (action === void 0) {
      action = {};
    }

    switch (action.__id) {
      case "ADD_QUERY":
        return [].concat(state, [action.query]);

      case "REMOVE_QUERY":
        return state.filter(function (query) {
          return !(0, _lodash.isEqual)(query.parent, action.parent);
        });

      default:
        return state;
    }
  }, []), (0, _operators.distinctUntilChanged)(), (0, _operators.shareReplay)(1));
  return {
    $: $,
    destroy: function destroy() {
      $.complete();
    },
    actions: {
      addQuery: function addQuery(_ref) {
        var parent = _ref.parent,
            hits = _ref.hits,
            label = _ref.label,
            icon = _ref.icon,
            color = _ref.color,
            type = _ref.type;
        return $.next({
          __id: "ADD_QUERY",
          query: {
            parent: parent,
            hits: hits,
            label: label,
            icon: icon,
            type: type
          }
        });
      },
      removeQuery: function removeQuery(parent) {
        return $.next({
          __id: "REMOVE_QUERY",
          parent: parent
        });
      }
    }
  };
};

var _default = QueryStore;
exports["default"] = _default;